import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LogTransport, LogEntry, LogLevel } from '../interfaces/logger.interface';

@Injectable()
export class LocalStorageTransport implements LogTransport {
  name = 'localStorage';
  private readonly storageKey = 'dod_app_logs';
  private readonly maxEntries = 1000;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    public minLevel: LogLevel = LogLevel.WARN
  ) {}

  log(entry: LogEntry): void {
    if (!isPlatformBrowser(this.platformId)) {
      return; // Local storage not available on server
    }

    try {
      const existingLogs = this.getLogs();
      existingLogs.push(entry);

      // Keep only the most recent entries
      if (existingLogs.length > this.maxEntries) {
        existingLogs.splice(0, existingLogs.length - this.maxEntries);
      }

      localStorage.setItem(this.storageKey, JSON.stringify(existingLogs));
    } catch (error) {
      console.error('Failed to save log to localStorage:', error);
    }
  }

  getLogs(): LogEntry[] {
    if (!isPlatformBrowser(this.platformId)) {
      return [];
    }

    try {
      const logs = localStorage.getItem(this.storageKey);
      return logs ? JSON.parse(logs) : [];
    } catch (error) {
      console.error('Failed to retrieve logs from localStorage:', error);
      return [];
    }
  }

  clearLogs(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    localStorage.removeItem(this.storageKey);
  }

  exportLogs(): string {
    const logs = this.getLogs();
    return JSON.stringify(logs, null, 2);
  }
}
